import React from "react";

const Strikethrough = ({ customComponent, onChange, isActive, isDisabled }) => {
	const toggleStrikethrough = () => {
		if (onChange) onChange();
	};

	return (
		<>
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={toggleStrikethrough}
				title="Strikethrough"
				type="button"
				disabled={isDisabled}>
				{customComponent ? (
					customComponent
				) : (
					<i className="fas fa-strikethrough" />
				)}
			</button>
		</>
	);
};

export default Strikethrough;
